import(/* webpackMode: "eager" */ "/Users/hezeying/mbti-web/app/pediat/page.jsx")